import type { FC } from "react";

import { Kbd } from "@/components/ui/kbd";
import { cn } from "@/lib/utils";

import type { ClientMode } from "../types";
import { ChoiceTile } from "./ChoiceTile";

export const CLIENT_MODE_OPTIONS: Array<{
  mode: ClientMode;
  shortcut: string;
  title: string;
  subtitle: string;
}> = [
  {
    mode: "new",
    shortcut: "1",
    title: "New Client",
    subtitle: "Add their name and email. We'll create the client with the case."
  },
  {
    mode: "existing",
    shortcut: "2",
    title: "Existing Client",
    subtitle: "Choose someone already in your client list."
  }
];

type Props = {
  value: ClientMode | null;
  onChoose: (mode: ClientMode) => void;
  className?: string;
};

export const ClientModeStep: FC<Props> = ({ value, onChoose, className }) => (
  <div className={cn("flex max-w-160 flex-col gap-2", className)}>
    {CLIENT_MODE_OPTIONS.map(({ mode, shortcut, title, subtitle }) => (
      <ChoiceTile
        key={mode}
        selected={value === mode}
        onSelect={() => onChoose(mode)}
        title={title}
        subtitle={subtitle}
        leading={<Kbd aria-hidden>{shortcut}</Kbd>}
      />
    ))}
  </div>
);
